module.exports = __webpack_public_path__ + "static/media/list-light-grey.bef2cb8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/list-light-grey.svg
// module id = 1951
// module chunks = 0